document.addEventListener("DOMContentLoaded", function(event) { 
  const CountDownZone = document.querySelector('#count-down-Timer strong');
  const TimeTarget = 9; // 14:00 PM es el tiempo de corte

  function pad(n, len) { // agregar ceros a la izquierda
    const s = n.toString();
    return '0'.repeat(Math.max(len - s.length, 0)) + s;
  };

  const timerRunning = setInterval(countDown, 1000);

  function countDown() {
    const localTime = new Date(); // obtener la hora local
    const utcTime = localTime.getUTCHours(); // obtener horas UTC
    const santiagoTime = new Date(localTime.getTime() - (5 * 60 * 60 * 1000)); // Ajustar para Santiago (UTC-3)

    // Verificar si el día actual es entre lunes y Sábado y si la hora actual es antes del corte
    if ((santiagoTime.getDay() >= 1) && (santiagoTime.getDay() <= 6) && // Lunes a Sábado
        (santiagoTime.getHours() < TimeTarget)) {
      
      const count_HM = [];
      const targetDate = new Date(santiagoTime); // Crear una nueva fecha para el tiempo de corte
      targetDate.setHours(TimeTarget, 0, 0, 0); // Establecer la hora de corte a 14:00 AM

      // Calcular la diferencia en milisegundos
      const timeDiff = targetDate - santiagoTime;

      // Convertir la diferencia a horas, minutos y segundos
      const hrs = Math.floor(timeDiff / (1000 * 60 * 60)); // horas
      const mins = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)); // minutos
      const secs = Math.floor((timeDiff % (1000 * 60)) / 1000); // segundos

      // Construir la visualización del countdown
      if (hrs > 0) { count_HM.push(hrs + ' hora(s)'); }
      if (hrs > 0 || mins > 0) { count_HM.push(pad(mins, 2) + ' minutos'); }
      count_HM.push(pad(secs, 2) + ' segundos');

     CountDownZone.textContent = count_HM.join(' - ');
} else {
  // Mostrar mensaje si el tiempo de corte ha pasado
  document.getElementById('count-down-Timer').innerHTML = 
    '<strong>Las 14:00 hrs. Tu pedido llegará Mañana. (Excepto domingos y festivos)</strong>';
  
  clearInterval(timerRunning);
}

  }
});